// The session lives in cookies that every tab of the browser shares, while each tab caches the
// customer it loaded. When another tab signs in as someone else (a staff member impersonating the
// next customer, or a customer switching accounts), this tab would send the new tokens with the
// previous customer's siteId, which the BFF's site-ownership check refuses. getCustomer stamps the
// cached customer with the contact id it was fetched for; getCurrentSession compares the two.

export function contactIdOf(idToken?: string): string | undefined {
    try {
        const payload = idToken?.split('.')[1];
        if (!payload) return undefined;
        const claims = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        return claims['custom:contactId'];
    } catch {
        return undefined;
    }
}

export function sessionMatchesCustomer(session: any, customer: any): boolean {
    const signedIn = contactIdOf(session?.idToken);
    if (!signedIn || !customer?.contactId) return true;
    return signedIn === customer.contactId;
}
